import { IDirectDebit } from "@/models/directDebit/directDebit.types"

export const getDirectDebitSorted = (directDebitMandates: IDirectDebit[]) => {
  let s = directDebitMandates
  if (s.length === 0) return undefined
  if (directDebitMandates.length > 1) {
    s = [...directDebitMandates].sort((a, b) => {
      if (!a.fromDttm || !b.fromDttm) return 0
      return a.fromDttm.isBefore(b.fromDttm) ? 1 : -1
    })
  }
  return s[0]
}

export const getDirectDebitDefaultMandate = (mandates: IDirectDebit[]) => {
  const defaultMandates = mandates.filter((m) => m.defaultStatus === "Default")
  if (defaultMandates.length) return getDirectDebitSorted(defaultMandates)

  const pendingMandates = mandates.filter((m) => m.defaultStatus === "Pending")
  if (pendingMandates.length) return getDirectDebitSorted(pendingMandates)

  const notDefaultMandates = mandates.filter(
    (m) => m.defaultStatus === "NotDefault",
  )
  return getDirectDebitSorted(notDefaultMandates)
}

export const formatSortCode = (sortCode: string) => {
  const sortCodeFormatted =
    sortCode.substring(0, 2) +
    "-" +
    sortCode.substring(2, 4) +
    "-" +
    sortCode.substring(4, 6)
  return sortCodeFormatted
}
